import { PropsWithChildren, useMemo, useState } from 'react';
import { AUTH_STEP, TAuthSteps } from '../constants';
import { AuthManagerContext } from './AuthManagerContext';

export const AuthManagerProvider = ({ children }: PropsWithChildren) => {
  const [step, setStep] = useState<TAuthSteps>(AUTH_STEP.DEFAULT);
  const [prefilledEmail, setPrefilledEmail] = useState<string>();
  const [phone, setPhone] = useState<{
    phoneWithCallingCode: string;
    phone?: string;
    countryCallingCode?: string;
  }>();

  const context = useMemo(() => {
    return {
      step,
      setStep,
      prefilledEmail,
      setPrefilledEmail,
      phone,
      setPhone,
    };
  }, [step, setStep, prefilledEmail, setPrefilledEmail, phone, setPhone]);

  return (
    <AuthManagerContext.Provider value={context}>
      {children}
    </AuthManagerContext.Provider>
  );
};
